import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import OfficeCubicleQuotesWrapper from "@components/layouts/officecubiclequotesWrapper";

export default function OfficeCubicleQuotesHome(): ReactElement {
    return (
        <OfficeCubicleQuotesWrapper>
            <TermsAndConditions
                domain="officecubiclequotes.com"
                category="Office Cubicles"
            />
        </OfficeCubicleQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
